import React, { useCallback, useEffect, useState } from "react";
import { Box } from "@mui/material";
import SwarmCard from "./swarmCard";
import DaysTabs from "./DaysTabs";
import VenueTabs from "./VenueTabs";
import { useLocation } from "react-router-dom";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const getSwarmsByDate = (swarms) => {
    
    // filter swarms with salesDate today
    let todaySaleSwarms = swarms.filter((swarm) => { 
        let sameDay = new Date(swarm.salesDate + "Z").getDate() <= new Date().getDate();
        let sameMonth = new Date(swarm.salesDate + "Z").getMonth() <= new Date().getMonth();
        let sameYear = new Date(swarm.salesDate + "Z").getFullYear() <= new Date().getFullYear();
        return ( (sameDay && sameMonth && sameYear) || swarm.isNow || swarm.isMonitor || swarm.isTraining);
        // return swarm.isNow
    });
    return todaySaleSwarms?.reduce((accumulator, currentSwarm) => {
        let key;
        
        if (currentSwarm.isNow && currentSwarm.running) {
            key = "Now";
        } else if (currentSwarm.isMonitor && currentSwarm.running) {
            key = "Monitor For Drops";
        } else if (currentSwarm.isTraining && currentSwarm.running) {
            key = "Training";
        } else {
            key = new Date(currentSwarm.salesDate);
        }
        if (key && currentSwarm.running) {
            accumulator[key] = [...(accumulator[key] || []), currentSwarm];
        }
        return accumulator;
    }, {}) || {};


    /**
 * This function takes an array of swarms and returns an object where the keys are either "Now" or the sales date of the swarm,
 * and the values are arrays of swarms that are currently running.
 * 
 * For example, if the input is:
 * [
 *   { isNow: true, running: true, salesDate: '2022-01-01' },
 *   { isNow: false, running: true, salesDate: '2022-01-02' },
 *   { isNow: false, running: false, salesDate: '2022-01-03' }
 * ]
 * 
 * The output would be:
 * {
 *   'Now': [{ isNow: true, running: true, salesDate: '2022-01-01' }],
 *   'Sat Jan 02 2022': [{ isNow: false, running: true, salesDate: '2022-01-02' }]
 * }
 * 
 * Note that the swarm with salesDate '2022-01-03' is not included because it is not currently running.
 * Also note that it first filters the swarms to only include those with salesDate today.
 */
}

const getSwarmsByDateSorted = (swarms) => {
    const swarmsByDate = getSwarmsByDate(swarms);

    return Object.entries(swarmsByDate).sort(([a], [b]) => {
        // "Training" goes last
        if (a === "Training") return 1;
        if (b === "Training") return -1;
        // "Monitor For Drops" goes before Training
        if (a === "Monitor For Drops") return 1;
        if (b === "Monitor For Drops") return -1;
        // "Now" goes first
        if (a === "Now") return -1;
        if (b === "Now") return 1;
        return new Date(a).getTime() - new Date(b).getTime();
    }).map(([label, items]) => {
        items.sort((a, b) => new Date(a.event.date).getTime() - new Date(b.event.date).getTime());
        return [label, items];
    });
/**
 * This function takes an array of swarms and returns a sorted array of tuples.
 * Each tuple consists of a label ("Now" or a date string) and an array of swarms for that date.
 * The swarms within each date are also sorted by their event date.
 * 
 * For example, if the input is:
 * [
 *   { isNow: true, running: true, salesDate: '2022-01-01', event: { date: '2022-01-01' } },
 *   { isNow: false, running: true, salesDate: '2022-01-02', event: { date: '2022-01-02' } },
 *   { isNow: false, running: true, salesDate: '2022-01-02', event: { date: '2022-01-03' } }
 * ]
 * 
 * The output would be:
 * [
 *   ['Now', [{ isNow: true, running: true, salesDate: '2022-01-01', event: { date: '2022-01-01' } }]],
 *   ['Sat Jan 02 2022', [
 *     { isNow: false, running: true, salesDate: '2022-01-02', event: { date: '2022-01-02' } },
 *     { isNow: false, running: true, salesDate: '2022-01-02', event: { date: '2022-01-03' } }
 *   ]]
 * ]
 */
}


export default function SwarmSelection({ swarms }) {
    const location = useLocation();
    const history = useHistory();

    const [selectedTimeTab, setSelectedTimeTab] = useState(null)
    const [selectedVenueTab, setSelectedVenueTab] = useState(null)
    console.log("selectedTimeTab", selectedTimeTab);
    console.log("selectedVenueTab", selectedVenueTab);

    const [sortedSwarms, setSortedSwarms] = useState([]);

    useEffect(() => {
        setSortedSwarms(getSwarmsByDateSorted(swarms));
    }, [swarms]);

    useEffect(() => {
        const updateSwarmSelection = () => {
            const sortedSwarms = getSwarmsByDateSorted(swarms);
            updateSelectedTimeTab(sortedSwarms);
            updateSelectedVenueTab(sortedSwarms);
        }
    
        updateSwarmSelection();
    }, [location, swarms]);

    const updateSelectedTimeTab = (sortedSwarms) => {
        const timeTabExists = sortedSwarms.some(([date]) => date === selectedTimeTab);
        if (!timeTabExists && sortedSwarms[0]) {
            setSelectedTimeTab(sortedSwarms[0][0]);
        }
    }
    
    const updateSelectedVenueTab = (sortedSwarms) => {
        const searchParams = new URLSearchParams(location.search)
        const searchedEvent = parseInt(searchParams.get("bteId"),10);
        const venueTabExists = sortedSwarms.some(([date, swarms]) => swarms.some(swarm => swarm.bteId == (searchedEvent || selectedVenueTab)));
    
        if ((!searchedEvent || !venueTabExists) && sortedSwarms[0] && sortedSwarms[0][1]) {
            setSelectedVenueTab(sortedSwarms[0][1][0].bteId);
        if (sortedSwarms[0] && sortedSwarms[0][1] && sortedSwarms[0][1][0]) {
            const newBteId = sortedSwarms[0][1][0].bteId;
            let searchParams = new URLSearchParams(location.search);
            searchParams.set("bteId", newBteId);
            history.replace({ search: searchParams.toString() });
            setSelectedVenueTab(newBteId);
        }
        } else {
            const index = sortedSwarms.findIndex(([date, swarms]) => swarms.some(swarm => swarm.bteId == (searchedEvent || selectedVenueTab)));
            setSelectedTimeTab(sortedSwarms[index]?.[0]);
            setSelectedVenueTab(parseInt(searchedEvent,10));
        }
    }

    const getSelectedSwarm = useCallback(() => {
        console.log("DEBUG: SwarmSelection: getSelectedSwarm: selectedVenueTab: ", selectedVenueTab)
        console.log("DEBUG: SwarmSelection: getSelectedSwarm: swarms: ", swarms)
        const selectedSwarm = swarms?.find((x) => x.bteId === parseInt(selectedVenueTab,10)); 
        console.log("DEBUG: SwarmSelection: getSelectedSwarm: selectedSwarm: ", selectedSwarm)
        
        return selectedSwarm;
    }, [selectedVenueTab,swarms]);

    const getdayEvents = useCallback(() => {
        return sortedSwarms.find(([date, swarms]) => date === selectedTimeTab)?.[1];
    }, [sortedSwarms, selectedTimeTab]);
    
    const handleVenueTabChange = useCallback((event, value) => {
        console.log("DEBUG: SwarmSelection: handleVenueTabChange: value: ", value)

        let searchParams = new URLSearchParams(location.search);
        searchParams.set("bteId", value);
        history.push({ search: searchParams.toString() });
    }, [history, location.search]);

    // Event handler for days tabs change
    const handleDaysTabChange = useCallback((event, value) => {
        console.log("DEBUG: SwarmSelection: handleDaysTabChange: value: ", value)
        setSelectedTimeTab(value);
        handleVenueTabChange(null, sortedSwarms.find(([date, swarms]) => date === value)[1][0]?.bteId)
    }, [sortedSwarms, handleVenueTabChange]);

    console.log("DEBUG: SwarmsSelection, sortedSwarms: ", sortedSwarms)
    console.log("DEBUG: SwarmsSelection, swarms: ", Object.values(getSwarmsByDate(swarms)));

    return (
    <Box sx={{ width: "100%" }}>
        <h3 style={{ margin: "0 0 0.25em 0" }}>Active Swarms</h3>
        {
        // check that there are swarms running for today by using getSwarmsByDate
        Object.values(getSwarmsByDate(swarms)).length === 0 ? (
            <h4
            style={{
                color: " var(--orange) ",
                fontWeight: "600",
                margin: "0 0 2em 0",
            }}
            >
            There are no active Swarms
            </h4>
        ) : (
            <>
            <DaysTabs
                sortedSwarms={sortedSwarms}
                selectedTimeTab={selectedTimeTab}
                handleTabChange={handleDaysTabChange}
            />
            {
                getdayEvents() &&
                    <VenueTabs
                        dayEvents={getdayEvents()}
                        selectedVenueTab={selectedVenueTab}
                        handleTabChange={handleVenueTabChange}
                    />
            }
            {
                getSelectedSwarm() &&
                    <SwarmCard
                        selectedSwarm={getSelectedSwarm()}
                    />
            }
            </>
        )
        }
    </Box>
    );
}